<template>
  <div>
    <el-dialog
      class="dialog-container"
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="550px"
      append-to-body
    >
      <el-form ref="form" :model="form" label-width="110px">
        <el-form-item label="供应商名称" prop="supplierName">
          <el-input
            v-model="form.supplierName"
            placeholder="请输入供应商名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="供应商代码" prop="supplierCode">
          <el-input
            v-model="form.supplierCode"
            placeholder="请输入供应商代码"
          ></el-input>
        </el-form-item>
        <el-form-item label="正审时间" prop="dateRange">
          <el-date-picker
            value-format="yyyy-MM-dd"
            v-model="form.dateRange"
            type="daterange"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer-button">
        <el-button type="primary" :loading="saveLoading" @click="handleSave">
          确定
        </el-button>
        <el-button type="primary" plain @click="dialogVisible = false">取消</el-button>
      </div>
    </el-dialog>
    <print-dialog :visible.sync="printDialogVisible" :print-data="printData" />
  </div>
</template>

<script>
import { getDownloadFiles } from "@/util/downFile";
import { threeGuaranteesExportApi, batchConfirmAmount, fillSecondList, threeGuaranteesPrintApi } from "@/api/seek";
import PrintDialog from "./printDialog.vue";

export default {
  components: {
    PrintDialog
  },
  data() {
    return {
      dialogVisible: false,
      saveLoading: false,
      form: this.getForm(),
      mode: "export",
      printDialogVisible: false,
      printData: []
    };
  },
  computed: {
    dialogTitle() {
      if (this.mode === "supplierConfirm") return "供应商确认";
      if (this.mode === "print") return "三包索赔单打印";
      return "三包索赔单导出";
    }
  },
  mounted() {},
  methods: {
    async init(mode = "export") {
      this.dialogVisible = true;
      this.mode = mode;
      this.form = this.getForm();
      this.$nextTick(() => {
        this.$refs.form.clearValidate();
      });
    },
    getForm() {
      return {
        supplierName: "",
        supplierCode: "",
        dateRange: []
      };
    },
    handleSave() {
      this.$refs.form.validate(async valid => {
        if (!valid) {
          return;
        }
        this.saveLoading = true;
        try {
          const submitData = JSON.parse(JSON.stringify(this.form));
          if ((submitData.dateRange || []).length === 2) {
            submitData.auditPassTimeStart = submitData.dateRange?.[0] + " 00:00:00";
            submitData.auditPassTimeEnd = submitData.dateRange?.[1] + " 23:59:59";
          }
          delete submitData.dateRange;

          if (this.mode === "supplierConfirm") {
            const listRes = await fillSecondList({
              data: {
                ...submitData,
                secondClaimStatus: "1"
              },
              page: {
                pageNum: 1,
                pageSize: 9999
              }
            });
            if (listRes.status === "0" && listRes.data.records.length > 0) {
              const claimStatementIdList = listRes.data.records.map(item => item.claimStatementId);
              const res = await batchConfirmAmount({ claimStatementIdList });
              if (res.status === "0") {
                this.$DonMessage.success("供应商确认成功");
                this.dialogVisible = false;
                this.$emit("confirmSuccess");
              } else {
                this.$DonMessage.error(res.message);
              }
            } else {
              this.$DonMessage.warning("未找到符合条件的索赔单");
            }
          } else if (this.mode === "print") {
            const res = await threeGuaranteesPrintApi(submitData);
            if (res.status === "0" && res.data && res.data.length > 0) {
              this.printData = res.data;
              this.printDialogVisible = true;
            } else {
              this.$DonMessage.warning("未找到符合条件的索赔单");
            }
          } else {
            const res = await threeGuaranteesExportApi(submitData);
            getDownloadFiles(res);
            if (res.fileName) {
              this.$DonMessage.success("导出成功！");
              this.dialogVisible = false;
            }
          }
        } catch (error) {
          console.error(error);
        }
        this.saveLoading = false;
      });
    }
  }
};
</script>